// ===================================================================
// src/app/lib/env.ts
//
// Configuração de ambiente do frontend Sophia.
//
// REGRA:
//   - VITE_API_URL definida → usa API real (production/staging)
//   - VITE_API_URL ausente  → usa mock local (dev sem backend)
//
// No .env do projeto Vite, defina APENAS o domínio base (sem /api/v1):
//   VITE_API_URL=https://api.elevemartech.com.br
// O prefixo /api/v1 é adicionado automaticamente por API_URL.
// ===================================================================

export const ENV = {
  /** URL base da API com /api/v1. Vazio = modo mock. */
  get API_URL(): string {
    const base = import.meta.env.VITE_API_URL?.replace(/\/+$/, '') || '';
    return base ? `${base}/api/v1` : '';
  },

  /** true quando a API real está configurada */
  get isApiMode(): boolean {
    return this.API_URL.length > 0;
  },

  /** true quando está em modo mock (sem backend) */
  get isMockMode(): boolean {
    return !this.isApiMode;
  },

  /** URL base da API de auth */
  get authUrl(): string {
    return `${this.API_URL}/auth`;
  },
} as const;